import { Meta, theme } from 'aimo-ui';
import InfoBox from 'components/common/InfoBox';
import Icon from 'components/icons/Icon';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ViewProps } from 'react-native';
import Animated, { FadeIn, FadeOut } from 'react-native-reanimated';
import { SimpleFullContainer } from 'styles/ContainerStyles';

const StreetConfirmationInfoBox = ({ ...props }: ViewProps) => {
  const { t } = useTranslation();
  return (
    <Animated.View
      {...props}
      exiting={FadeOut.duration(200)}
      entering={FadeIn.duration(300)}>
      <InfoBox
        padding={15}
        margin={0}
        boxAlign="flex-start"
        bgColor={theme.colors.lightBg.green}
        leftComponent={
          <Icon name="Info-Outlined" testID={'street-confirm-info'} />
        }>
        <SimpleFullContainer>
          <Meta>{t('parking.streetParkingPrompt')}</Meta>
        </SimpleFullContainer>
      </InfoBox>
    </Animated.View>
  );
};

export default StreetConfirmationInfoBox;
